module.exports = __webpack_public_path__ + "static/media/ic_chevron-right-gray.dd17d06f.svg";